var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "panel granary-right-panel" },
    [
      _c(
        "bar-card",
        { attrs: { bg: "border-new" } },
        [
          _c("g-title", { attrs: { bg: "jxhsp" } }, [_vm._v("机械化水平")]),
          _c("div", { staticClass: "content" }, [
            _c("div", { staticClass: "jxh-box flex" }, [
              _c("div", { staticClass: "jxh-zp flex" }, [
                _c("img", {
                  attrs: {
                    src: require("images/granary/zzy/njzdl-bg.png"),
                    alt: "",
                  },
                }),
                _c("div", { staticClass: "zp" }, [
                  _c("p", { staticClass: "num" }, [
                    _vm._v(_vm._s(_vm.nyjxzdl)),
                  ]),
                  _c("p", { staticClass: "zp-name" }, [
                    _vm._v("农业机械总动力"),
                  ]),
                  _c("p", { staticClass: "zp-dw" }, [_vm._v("(万千瓦)")]),
                ]),
              ]),
              _c("div", { staticClass: "jxh-zp jxh-zp2 flex" }, [
                _c("img", {
                  attrs: {
                    src: require("images/granary/zzy/zhjxhsp-bg.png"),
                    alt: "",
                  },
                }),
                _c("div", { staticClass: "zp" }, [
                  _c("p", { staticClass: "num" }, [
                    _vm._v(_vm._s(_vm.znjzymj)),
                  ]),
                  _c("p", { staticClass: "zp-name" }, [
                    _vm._v("总农机作业面积"),
                  ]),
                  _c("p", { staticClass: "zp-dw" }, [_vm._v("(千公顷)")]),
                ]),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "nyjx-box flex" },
              _vm._l(_vm.mjList, function (item, i) {
                return _c("div", { key: i, staticClass: "jxh-item" }, [
                  _c("p", { staticClass: "num" }, [_vm._v(_vm._s(item.num))]),
                  _c("p", { staticClass: "fl-name" }, [
                    _vm._v(_vm._s(item.name) + "(" + _vm._s(item.unit) + ")"),
                  ]),
                ])
              }),
              0
            ),
            _c(
              "div",
              { staticClass: "znj-box flex" },
              _vm._l(_vm.spList, function (item, i) {
                return _c("div", { key: i, staticClass: "jxh-item" }, [
                  _c("p", { staticClass: "num" }, [_vm._v(_vm._s(item.num))]),
                  _c("p", { staticClass: "fl-name" }, [
                    _vm._v(_vm._s(item.name) + "(" + _vm._s(item.unit) + ")"),
                  ]),
                ])
              }),
              0
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }